import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "real-time-data-row__cell real-time-data-row__cell--heading" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  title?: string;
  data: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'real-time-data-row',
  props: {
    modifires: { type: [String, Array, Boolean] },
    title: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(_unref(mapModifires)('real-time-data-row', _ctx.modifires))
  }, [
    _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.title), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
      return (_openBlock(), _createElementBlock("td", {
        key: i,
        class: "real-time-data-row__cell"
      }, _toDisplayString(item), 1))
    }), 128))
  ], 2))
}
}

})